module.exports = __webpack_public_path__ + "img/certification.cd9e454c.jpg";